/** Faint teal-tinted neutral behind home page sections and the service search; blue and teal stay accents. */
export const MINT_MIST = '#f2f8f5';
